import React from 'react';
import classNames from 'classnames/bind';

import Styles from './TutorialVideo.styles';
import { trackEvent, ONBOARDING_EVENTS } from './../../../tracking';

const context = classNames.bind(Styles);

function useYouTubePlayerEffect(elementId, videoId, onReady, onStateChange) {
  const [player, setPlayer] = React.useState(null);

  function createPlayer() {
    const newPlayer = new window.YT.Player(elementId, {
      videoId,
      events: {
        onReady,
        onStateChange,
      },
    });
    setPlayer(newPlayer);
  }

  React.useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.onYouTubeIframeAPIReady = () => createPlayer();
    } else {
      createPlayer();
    }
    return () => {
      window.onYouTubeIframeAPIReady = undefined;
    };
  }, []);

  return player;
}

function onPlayerReady() {
  trackEvent(ONBOARDING_EVENTS.VIDEO_LOADED);
}

function onPlayerEvent(event) {
  if (event.data === window.YT.PlayerState.PLAYING) {
    trackEvent(ONBOARDING_EVENTS.VIDEO_PLAYED);
  } else if (event.data === window.YT.PlayerState.ENDED) {
    trackEvent(ONBOARDING_EVENTS.VIDEO_ENDED);
  }
}

const AutomatedTestsVideo = () => {
  const playerElementId = 'automated-tests-youtube-embed';
  const videoId = 'wWgpnw97o54';
  useYouTubePlayerEffect(playerElementId, videoId, onPlayerReady, onPlayerEvent);

  return (
    <>
      <h3>Explore the test details page</h3>
      <div className={context('video-container')}>
        <iframe
          allow="allow-scripts; encrypted-media;"
          allowFullScreen
          className={context('video-iframe')}
          frameBorder="0"
          id={playerElementId}
          src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
          title="Explore the test details page"
        />
      </div>
      <p>
        {`Watch this video to see what information you have access to after an automated
        test is run.`}
      </p>
      <p>
        {'For more information visit our '}
        <a
          href="https://wiki.saucelabs.com/display/DOCS/Enhanced+Test+Details+Page#EnhancedTestDetailsPage-AccessingtheTestDetailsPage"
          onClick={() => trackEvent(ONBOARDING_EVENTS.DOCUMENTATION_OPEN)}
          rel="noopener noreferrer"
          target="_blank"
        >
          documentation
        </a>
        {'.'}
      </p>
    </>
  );
};

export default AutomatedTestsVideo;
